import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../_services';
import { environment } from '../../environments/environment';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor(private _US: UserService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let isJson = this.isStringJSON(localStorage.getItem("oneHomeCurrentUser")!);
    let decryptedData: any;
    if (isJson) {
      decryptedData = JSON.parse(localStorage.getItem("oneHomeCurrentUser")!);
    } else {
      decryptedData = localStorage.getItem("oneHomeCurrentUser")! ? this._US.getDecryptData(localStorage.getItem("oneHomeCurrentUser")!) : null;
    }
    const oneHomeCurrentUser = decryptedData;
    if (oneHomeCurrentUser && oneHomeCurrentUser.token && oneHomeCurrentUser.userId) {
      request = request.clone({
        headers: new HttpHeaders({
          authKey: oneHomeCurrentUser.token,
          sslpinning: environment.sslPinning
        })
      });
    } else {
      request = request.clone({
        headers: new HttpHeaders({
          sslpinning: environment.sslPinning
        })
      });
    }
    return next.handle(request);
  }

  isStringJSON(str: string): boolean {
    try {
      JSON.parse(str);
      return true;
    } catch (error) {
      return false;
    }
  };

}
